import { scrollToSection } from "@/lib/scroll";

// Lleva al formulario de presupuesto de la portada con el detalle ya cargado.
//
// Punto unico para los tres botones que piden presupuesto (calculadora, ficha de
// producto y carrito), que antes hacian cada uno una cosa distinta. El scroll va
// aparte del hash porque ScrollManager solo reacciona a cambios de pathname o
// hash: si el visitante ya venia de "/#presupuesto" no se movia nada.
export const goToQuote = (nav, prefill) => {
    sessionStorage.setItem("lr_quote_prefill", JSON.stringify(prefill));
    nav("/#presupuesto");
    scrollToSection("#presupuesto");
    setTimeout(() => window.dispatchEvent(new Event("lr-quote-prefill")), 400);
};
